import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardBody,
  CCol,
  CFormSelect,
  CRow,
  CSmartTable,
  CTable,
  CTableBody,
  CTableHead,
} from '@coreui/react-pro'
import moment from 'moment'
import PlayerService from 'src/service/PlayerService'
const FixturePlayerStatsIndoorTab = (props) => {
  const [statsData, setStatsData] = useState([])
  const handlePlayer = (e) => {
    const playerId = e.target.value
    PlayerService.playerStatsByFixture(playerId).then((res) => {
      if (res.success) {
        setStatsData(res.data)
      }
    })
  }
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol>
              <CFormSelect
                aria-label="Select player"
                name="player"
                className={'form-control'}
                onChange={handlePlayer}
                id="player"
              >
                <option value={0}>Select Player</option>
                {props.playerList &&
                  props.playerList.map((item, key) => (
                    <option value={item?.id} key={key}>
                      {item?.full_name}
                    </option>
                  ))}
              </CFormSelect>
              <div className="table-responsive">
                <CTable className="main-table table innertable">
                  <CTableHead color="dark">
                    <tr>
                      <th>Date</th>
                      <th>Team</th>
                      <th>FP</th>
                      <th>POS</th>
                      <th>RS</th>
                      <th>1S</th>
                      <th>2S</th>
                      <th>3S</th>
                      <th>4S</th>
                      <th>5S</th>
                      <th>6S</th>
                      <th>7S</th>
                      <th>8S</th>
                      <th>9S</th>
                      <th>OVR</th>
                      <th>MDN</th>
                      <th>WKS</th>
                      <th>CS</th>
                      <th>CWK</th>
                      <th>STS</th>
                      <th>ROD</th>
                      <th>ROA</th>
                      <th>DKS</th>
                      <th>HT</th>
                    </tr>
                  </CTableHead>
                  <CTableBody>
                    {statsData &&
                      statsData.map((item, key) => (
                        <tr key={key}>
                          <td> {moment(item.fixture.start_date).format('D.MM.YYYY')}</td>
                          <td>{item?.teamName}</td>
                          <td>{item.fantasy_points}</td>
                          <td>{item.position_name}</td>
                          <td>{item?.rs}</td>
                          <td>{item?.ones}</td>
                          <td>{item?.twos}</td>
                          <td>{item?.threes}</td>
                          <td>{item?.fours}</td>
                          <td>{item?.fives}</td>
                          <td>{item?.sixes}</td>
                          <td>{item?.sevens}</td>
                          <td>{item?.eights}</td>
                          <td>{item?.nines}</td>
                          <td>{item?.overs}</td>
                          <td>{item?.mdns}</td>
                          <td>{item?.wks}</td>
                          <td>{item?.cs}</td>
                          <td>{item?.cwks}</td>
                          <td>{item?.sts}</td>
                          <td>{item?.rods}</td>
                          <td>{item?.roas}</td>
                          <td>{item?.dks}</td>
                          <td>{item?.hattrick}</td>
                        </tr>
                      ))}
                    {statsData.length === 0 && (
                      <tr>
                        <td colSpan={15}>No record yet available.</td>
                      </tr>
                    )}
                  </CTableBody>
                </CTable>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default FixturePlayerStatsIndoorTab
